<template>
    <zk-admin-table title="预约排期" :loading="loading" :table="table" @change="handleTableChange" @select="handleTableSelect">
        <template v-slot:buttons>
            <el-row style="float: right">
                <selectHospital v-if="permission.task_scheduling" v-model="search.hospital_id" style="margin-right:10px" @input="getData" />
                <el-button size="mini" icon="el-icon-search" circle @click="searchVisible = !searchVisible"></el-button>
                <el-button size="mini" icon="el-icon-refresh" circle @click="getData"></el-button>
                <!-- <el-button size="mini" icon="el-icon-download" circle @click="doDownLoad"></el-button> -->
                <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="handleAdd"></el-button>
                <!-- <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleMultiUpdate"></el-button> -->
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete"></el-button>
            </el-row>
        </template>
        <template v-slot:search>
            <search-form @search="handleSearch" :form="search" v-show="searchVisible" />
        </template>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" v-for="(v, idx) in table.columns" :prop="v.field" :label="v.title" :width="v.width"
            :formatter="v.formatter" :key="idx">
        </el-table-column>
        <template v-slot:dialog>
            <data-form :visible="dialogVisible" :form="form" @close="dialogClose" @update="getData">
            </data-form>
        </template>
        <template v-slot:download>
            <data-down-load :visible="downloadVisible" :form="search" :total="table.total"
                @close="downloadVisible = false"></data-down-load>
        </template>
    </zk-admin-table>
</template>

<script>
import DataForm from './widgets/dataForm'
import SearchForm from './widgets/searchForm'
import DataDownLoad from './widgets/dataDownLoad'
import data from './data'

export default {
    name: 'task-scheduling-form',
    path: '/main/task/scheduling/form',
    components: {
        DataForm,
        SearchForm,
        DataDownLoad
    },
    data() {
        return {
            loading: false,
            table: data.table,
            dialogVisible: false,
            searchVisible: true,
            downloadVisible: false,
            search: {daterange:[]},
            permission: {},
            form: {},
            isNew: false,
            multipleSelection: []
        }
    },
    methods: {
        dialogClose() {
            this.dialogVisible = false
            this.getData()
        },
        doDownLoad() {
            this.downloadVisible = true
        },
        handleAdd() {
            this.form = {
                dates: [],
                times: [
                    { time: '08:00-09:00', count: 200 },
                    { time: '09:00-10:00', count: 200 },
                    { time: '13:00-14:00', count: 100 },
                    { time: '13:00-14:00', count: 50 }
                ]
            }
            if (this.$store.getters.username == 'lnyy') {
                this.form.times = [
                    { time: '07:30-08:20', count: 50 },
                    { time: '08:20-09:20', count: 100 },
                    { time: '09:20-10:00', count: 50 },
                    { time: '13:30-14:20', count: 10 }
                ]
            }
            if (this.$store.getters.username == 'rmyy') {
                this.form.times = [
                    { time: '08:00-09:00', count: 50 },
                    { time: '09:00-10:00', count: 50 },
                    { time: '10:00-11:00', count: 10 }
                ]
            }
            if (this.$store.getters.username == 'deyy') {
                this.form.times = [
                    { time: '08:00-09:00', count: 50 },
                    { time: '09:00-10:00', count: 50 }
                ]
            }
            this.isNew = true
            this.dialogVisible = true
        },
        handleSearch(e) {
            this.search = e
            this.table.page = 1
            this.getData()
        },
        handleTableChange(e) {
            this.table = e
            this.getData()
        },
        handleTableSelect(val) {
            this.multipleSelection = val
        },
        async handleMultiUpdate() {
            if (this.multipleSelection.length !== 1) {
                this.$message.error('请选择一条记录')
                return
            }
            this.handleUpdate(this.multipleSelection[0])
        },
        async handleUpdate(row) {
            this.isNew = false
            var temp = JSON.stringify(row)
            this.form = JSON.parse(temp)
            this.dialogVisible = true
        },
        async handleDelete() {
            this.loading = true
            if (this.multipleSelection.length < 1) {
                this.$message.error('请选择要删除的对象')
                return
            }
            for (const e of this.multipleSelection) {
                await this.$http.delete(`/task/scheduling/times/${e.id}`)
            }
            this.$message.success('删除成功')
            this.getData()
            this.loading = false
        },
        async getData() {
            this.loading = true
            try {
                const resp = await this.$http.get(`/task/scheduling/times?page=${this.table.page}&pageSize=${this.table.pageSize}`, { params: this.search })
                if (!resp.data) {
                    this.$message.error(resp.data.msg)
                } else {
                    this.table.data = resp.data.data.records
                    this.table.total = resp.data.data.total
                }
            } catch (e) {
                this.$message.error(e.message)
            }
            this.loading = false
        },
        async getPermission() {
            const resp = await this.$http.get('/permission')
            this.permission = resp.data
        }
    },
    mounted() {
        console.log(this.$route.params)
        if (this.$route.params.date) {
            this.search.daterange = [this.$route.params.date, this.$route.params.date]
            this.search.hospital_id = this.$route.params.hospital_id
        }
        this.getData()
        this.getPermission()
    }
}
</script>

<style scoped></style>